import { ACTION_GIFTCODE_CLAIM, ACTION_GIFTCODE_CLAIM_ERROR, ACTION_GIFTCODE_CLAIM_SUCCESS } from "../actions";

const initState = {
    isLoading: false,
    erro_msg: undefined,
    chip: undefined
}


export const giftcodeClaimReducer = (state = initState, action = {}) => {
    switch (action.type) {
        case ACTION_GIFTCODE_CLAIM:
            return { ...state, isLoading: true, erro_msg: undefined, chip: undefined }
        case ACTION_GIFTCODE_CLAIM_SUCCESS:
            return { ...state, isLoading: false, erro_msg: action.payload.msg, chip: action.payload.chip }
        case ACTION_GIFTCODE_CLAIM_ERROR:
            return { ...state, isLoading: false, erro_msg: action.payload.msg };
        default:
            return state;
    }
}